/**
 * Initialize global error handlers for uncaught errors and unhandled promise rejections
 */

function handleGlobalError(event: ErrorEvent) {
  console.error("Uncaught error:", event.error);
  // The error will bubble up to the Error Boundary if it happens during render
  // If it happens outside React, this at least logs it
}

function handleUnhandledRejection(event: PromiseRejectionEvent) {
  console.error("Unhandled promise rejection:", event.reason);
  // In development, we might want to let this propagate; in production we should send to monitoring/faro once implemented
}

export function initializeGlobalErrorHandlers() {
  if (typeof window === "undefined") {
    return;
  }

  const win = window as typeof window & { __globalErrorHandlersInitialized?: boolean };
  if (win.__globalErrorHandlersInitialized) {
    return;
  }

  window.addEventListener("error", handleGlobalError);
  window.addEventListener("unhandledrejection", handleUnhandledRejection);

  win.__globalErrorHandlersInitialized = true;
}
